<script lang="ts">
    import { Component, Vue, Prop } from 'vue-facing-decorator';
    import { CurrencyHandler, TranslationKey } from "webshop-modules";
    import { FeeList, TicketFeeCalculator } from "@/domain/ticket-selection";

    @Component({})
    export default class TicketFeeInfo extends Vue {

        @Prop() public readonly currencyHandler!: CurrencyHandler;
        @Prop() public readonly hasOpacity = true;
        @Prop() public readonly ticketPriceList: number[] = [];
        @Prop() public readonly feeList: FeeList[] = [];

        public readonly Translation: typeof TranslationKey = TranslationKey;
        public readonly TicketFeeCalculator: typeof TicketFeeCalculator = TicketFeeCalculator;

        public get canDisplayTicketFees(): boolean {
            return this.feeList.length > 0 && this.feeList.some(fee => fee.value > 0) && !!this.currencyHandler;
        }

        public get totalFeeValue(): number {
            return this.ticketPriceList.length > 0 ?
                this.TicketFeeCalculator.calculateFeeFor(this.ticketPriceList, this.feeList)
                : 0;
        }

        public get totalTicketValue(): number {
            return this.ticketPriceList.reduce((acc, price) => acc + price, 0);
        }

        public get totalValue(): number {
            return this.totalTicketValue + this.totalFeeValue;
        }

    }
</script>

<template>
    <div v-if="canDisplayTicketFees"
         v-bind:class="{ '-opacity': hasOpacity, '-morePadding': currencyHandler.isSecondaryCurrencyDisplayed }"
         class="a-FeeInfo__container">
        <div class="a-feeInfo__valueDisplay">
            <div class="a-feeInfo__primary">
                <div class="a-feeInfo__valueTitle">
                    <span v-translate="{ key: Translation.Ticket_fees }"></span>:
                </div>
                <span class="a-feeInfo__value">{{ currencyHandler.displayPrimaryCurrency(totalFeeValue)}}</span>
            </div>
            <div v-if="currencyHandler.isSecondaryCurrencyDisplayed" class="a-feeInfo__value">
                <span>{{ currencyHandler.displaySecondaryCurrency(totalFeeValue)}}</span>
            </div>
        </div>
        <div class="a-feeInfo__valueDisplay">
            <div class="a-feeInfo__primary">
                <div class="a-feeInfo__valueTitle">
                    <span v-translate="{ key: Translation.Ticket_total }"></span>:
                </div>
                <span class="a-feeInfo__value">{{ currencyHandler.displayPrimaryCurrency(totalValue)}}</span>
            </div>
            <div v-if="currencyHandler.isSecondaryCurrencyDisplayed" class="a-feeInfo__value">
                <span>{{ currencyHandler.displaySecondaryCurrency(totalValue)}}</span>
            </div>
        </div>
    </div>
</template>